module.exports = __webpack_public_path__ + "static/media/air.b95600be.svg";